(function () {
  const button = document.querySelector('.hd-back-to-top');
  if (!button) return;

  const showAt = 480;

  const toggleVisibility = () => {
    const visible = window.scrollY > showAt;
    button.hidden = !visible;
    button.classList.toggle('is-visible', visible);
  };

  window.addEventListener('scroll', toggleVisibility, { passive: true });
  toggleVisibility();

  button.addEventListener('click', () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
})();
